import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountTypeCssProviderService } from '../providers/account-type-css-provider.service';
import { AccountType } from '../enums/account-type';

@Pipe({
  name: 'accountTypeCss',
  standalone: true,
})
export class AccountTypeCssPipe implements PipeTransform {
  private readonly provider = inject(AccountTypeCssProviderService);

  public transform(type: AccountType): Observable<string> {
    return this.provider.css(type);
  }
}
